import store from '../store';

export default (to, from, next) => {
	const user = store.state.user.user;
	const loggedInWithSocialNetworks = !!user.identities.length;

	if (loggedInWithSocialNetworks) {
		if (from.name === 'myAccount') {
			store.dispatch('CHANGE_LOADING_STATE', false);
		}
		next({
			name: 'myAccount'
		});
	} else {
		next();
	}
}